import { Component, OnInit, ViewChild } from '@angular/core';
import { DiscountService } from 'src/app/services/discount.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { NgxSmartModalComponent } from 'ngx-smart-modal';

@Component({
  selector: 'app-manage-discount',
  templateUrl: './manage-discount.component.html',
  styleUrls: ['./manage-discount.component.scss']
})
export class ManageDiscountComponent implements OnInit {
  constructor(private discountService: DiscountService, private spinner: SpinnerService) { }
  Object = Object;

  discounts: any[];
  selected: any = {};
  total = 0;
  limit = 100;
  keyword = '';
  disabled = false;

  @ViewChild('discountModal') discountModal: NgxSmartModalComponent;
  async ngOnInit() {
    await this.load();
  }

  async load(from = 0) {
    this.spinner.show();
    const result = await this.discountService.search({ Keyword: this.keyword, Disabled: this.disabled }, from, this.limit);
    this.discounts = result.discounts;
    this.total = result.total;
    this.spinner.hide();
  }

  open(discount?: any) {
    this.selected = Object.assign({}, discount || {});
    this.discountModal.open();
  }

  async delete(id: string) {
    this.spinner.show('action');
    await this.discountService.delete(id);
    this.spinner.hide('action');
    await this.load();
  }

  async save() {
    this.spinner.show('action');
    await this.discountService.save(this.selected);
    this.spinner.hide('action');
    this.discountModal.close();
    await this.load();
  }
}
